"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setupPOD_STATUS_NOT_CONTAINERS_READY = void 0;

var validator_id_1 = require("../../../validator-id");

var categories_1 = require("../../categories");

function setupPOD_STATUS_NOT_CONTAINERS_READY(builder) {
  builder.validator(validator_id_1.ValidatorID.POD_STATUS_NOT_CONTAINERS_READY).category(categories_1.ValidatorCategory.Compute).subCategory(categories_1.ValidatorSubCategory.Status).title('Stage 2. Pod containers not ready').description("During the launch, Pods go through a sequence of execution stages.\nRight after scheduling the Pod on the Node, Kubernetes will start preparing\nthe containers. \n\nThis validator detects at least one of the containers within this Pod is not ready.\n").affected('Pod').example("\nkind: Pod\n...\nstatus:\n  conditions:\n    - type: ContainersReady\n      status: \"False\"\n      lastProbeTime: null\n      lastTransitionTime: 2022-01-01T00:00:00Z\n  containerStatuses:\n    - containerID: docker://abcd...\n      ready: true      \n") // TODO: When does this happen? 
  // TODO: Resolutions?
  // TODO: Failed to pull an image?
  .externalLink('https://kubernetes.io/docs/concepts/workloads/pods/pod-lifecycle/');
}

exports.setupPOD_STATUS_NOT_CONTAINERS_READY = setupPOD_STATUS_NOT_CONTAINERS_READY;